import React from 'react';
import Grid from "@material-ui/core/Grid";
import { Redirect } from 'react-router';
import { isLogin } from '../../../../services/AuthService';
import UserContext from '../../../../utils/UserContext';
import NotAuthorized from '../../../../components/ShareComponents/NotAuthorized/NotAuthorized';
import { permissionGraduateMassMessageView } from '../../../../utils/PermissionsVariables';
import { containsAny } from '../../../../helpers/sharedFunctions';
import MassMessageGraduate from '../../../../components/MassMessage/MassMessageGraduate';

const MassMessageManagementGraduate: React.FC = () => {
  const userContext = React.useContext(UserContext);

  return (
    <>
    {isLogin() ?
      <>
        <Grid container className="main-container">
          {containsAny(permissionGraduateMassMessageView,userContext.userPermissions) ?
            <Grid container item xs={12}>
              <MassMessageGraduate/>
            </Grid>
          :
            <NotAuthorized/>
          }
        </Grid>
      </>
    :
      <Redirect to ="/"/>
    }
    </>
  )
}

export default MassMessageManagementGraduate
